import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { StickyBottomBorder } from 'owa-editor-docking-plugin';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

import styles from './FullComposeLeftPane.scss';
const SCROLL_CONTAINER_SELECTOR = '.customScrollBar';
interface FullComposeStickyBottomBorderProps {
    formId: string;
}

const FullComposeStickyBottomBorder = observer(function FullComposeStickyBottomBorder(
    props: FullComposeStickyBottomBorderProps
) {
    const { docking, bodyViewState } = getFullComposeViewState(props.formId);

    if (!docking?.useStickyDocking) {
        return null;
    }

    return (
        <StickyBottomBorder
            editorViewState={bodyViewState}
            dockingViewState={docking}
            scrollContainerSelector={SCROLL_CONTAINER_SELECTOR}
            className={styles.stickyBottomBorder}
        />
    );
});

export default FullComposeStickyBottomBorder;
